<div class="d-flex justify-content-between align-items-center p-2">
  <div class="bulk-upload-head">
    <span class="bulk-dispatch-timer">Bulk Invoice Edit</span>
    <div class="bulk-display-timer">
      <img src="./assets/images/timer-svgrepo-com.svg" alt="timer-img" class="timer-img filter-invert">
      <span class="carrier-text-alignment width-thirty bulk-dispatch-timer">{{displayTimer()}}</span>
    </div>
  </div>
  <div class="d-flex align-items-center">
    <button class="custom-button-compact p-button" (click)="save()"
      [disabled]="!form?.valid  || showWarning || (uploads.length < 1 && !allUncollectible)">Save</button>
    <button class="custom-button-compact p-button" style="margin-left: 12px;" (click)="applyValuesToAll()" [disabled]="!isFirstInvoiceValid">Apply Values to All</button>
    <div class="link-button ml-2">
      <a class="muted7"  (click)="cancelClick()"><img
          src="./assets/images/close.svg" alt="close-img" class="filter-invert" /></a>
    </div>
  </div>
</div>
<div class="bulk-warning-msg py-0 px-2">
  <div class="warning-red">
    <div *ngIf="showWarning" class="bulk-warning"><img src="./assets/images/alert.svg" alt="warning-img"><span class="ml-1"> Warning:
      There is no "Is FSC Paid" value as Partial, please select at least 1 Partial!</span></div>
  </div>
</div>
<ng-container>
  <div class="accounting-bulk accounting-bulk-bg">
    <div class="row accounting-bulk accounting-bulk-cards">
      <div class="col-12 accounting-bulk-uploads">
        <div class="small-text italic text-align-center mt-2"
        style="color:#b00; text-align: right; width: 100%; display: inline-block" *ngIf="uploads.length < 1 && !allUncollectible">
        <ng-container>
          <img src="./assets/images/alert.svg" alt="alert-img"/> Please upload atleast one file to proceed with bulk edit
        </ng-container>
      </div>
        <uploads [orderId]="0" [orderGuid]="null" (rowsChange)="changeUploads($event)" [addLabel]="'Add Attachments'" [type]="2"  class="accounting-upload-btn"></uploads>
      </div>
    </div>
    <form [formGroup]="form" *ngIf="!isLoading">
      <div class="row accounting-bulk bulk-order-list accounting-bulk-cards">
        <ng-container [formArrayName]="'bulkEditInvoice'" *ngFor="let f of bulkEditInvoice?.controls; let i = index;">
          <ng-container [formGroupName]="i">
            <div class="col-12">
              <div class="row accounting-border-bottom">
                <div class="col-6 py-0 pr-0 my-2 invoice-border">
                  <div class="accounting-balance-due d-flex accounting-border-bottom">
                    <div class="f-w-bold pb-1"> Invoice # </div>
                    <div class="f-w-bold pb-1">{{modal[i]?.number}}</div>
                  </div>
                  <div class="pt-3">
                    <div *ngFor="let v of modal[i]?.vehicles">
                      <div class="f-w-bold">{{metadata['vin']}}: {{v.vin}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-6 pl-0 py-0 my-2">
                  <div class="accounting-balance-due d-flex accounting-border-bottom">
                    <div class="f-w-bold pb-1 ml-2">{{metadata['balancedue']}}:</div>
                    <div class="f-w-bold pb-1 ml-2">$ {{modal[i]?.balanceDue}}</div>
                  </div>
                  <table class="ml-2 mt-1 w-100">
                    <tbody>
                      <tr>
                        <td class="f-w-bold w-twenty">{{metadata['invoicePaid']}}:</td>
                        <td>
                          <simple-control [class]="'w-25'" [label]="metadata['invoicePaid']" [form]="f" key="invoicePaid"
                            type="lookup" [items]="lookups.fscpaidbycustomer"></simple-control>
                        </td>
                      </tr>
                      <tr *ngIf="showValidationFlags[i]">
                        <td class="f-w-bold">{{metadata['partialAmountPaid']}}:</td>
                        <td>
                          <simple-control [class]="'w-50'" [label]="metadata['partialAmountPaid']" [form]="f"
                            key="partialAmountPaid" type="currency"></simple-control>
                        </td>
                      </tr>
                      <tr>
                        <td class="f-w-bold">{{metadata['fscPaidBy']}}: </td>
                        <td>
                          <simple-control [class]="'w-50'" [label]="metadata['fscPaidBy']" [form]="f" key="fscPaidBy"
                            type="lookup" [items]="lookups.paymentMethod" [readonly]="f?.get('invoicePaid')?.value == 3 || f?.get('invoicePaid')?.value == 5" [readonlyLabel]="'N/A'"></simple-control>
                        </td>
                      </tr>
                      <tr *ngIf="showfscPaidByOther[i]">
                        <td class="f-w-bold">{{metadata['fscPaidByOther']}}</td>
                        <td>
                          <simple-control [class]="'w-50'" [label]="metadata['fscPaidByOther']" [form]="f" key="fscPaidByOther" type="text">
                          </simple-control>
                        </td>
                      </tr>
                      <tr>
                        <td class="f-w-bold">{{metadata['fscPaidDate']}}: </td>
                        <td>
                          <simple-control [class]="'w-25'" [label]="metadata['fscPaidDate']" [form]="f" key="fscPaidDate"
                            type="date" [readonly]="f?.get('invoicePaid')?.value == 3 || f?.get('invoicePaid')?.value == 5" [readonlyLabel]="'N/A'"></simple-control>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div class="accounting-bulk d-flex flex-column align-items-center p-3 accounting-bulk-cards">
        <div class="row mb-2 w-100 flex-nowrap align-items-center">
          <h5 class="my-0 mr-1 font-weight-bold col-6 text-right">Total Balance Due:</h5>
          <span class="total-amount font-weight-bold col-6" style="padding-left: 7px;">$ {{ totalBalanceDue }}</span>
        </div>
        <div class="row mb-2 w-100 flex-nowrap">
          <h5 class="my-0 mr-1 font-weight-bold pt-1 col-6 text-right">Total Amount Received: </h5>
          <simple-control [label]="'Total Amount Received'" [form]="form" key="total"
            [class]="'font-weight-bold total-amount total-amount-received'" type="currency"></simple-control>
        </div>
      </div>
    </form>
  </div>
</ng-container>

<p-dialog [(visible)]="showCancelWarningDailog" [style]="{width: '25vw'}" [modal]="true" [showHeader]="false"
  [closable]="false" appendTo="body">
  <div class="modal-body-custom">
    <div class="regular-text muted6 bold">
      Are you sure you want to abandon this bulk Edit Invoice? Data will not be saved.
    </div>
  </div>
  <div class="ui-dialog ui-dialog-footer">
    <div class="modal-footer-custom">
      <div class="link-button d-inline-block">
        <a class="muted7" (click)="showCancelWarningDailog = false;">No</a>
      </div>
      <div class="link-button float-right d-inline-block">
        <button class="link-button" type="button" (click)="cancel()">Yes</button>
      </div>
    </div>
  </div>
</p-dialog>
